var map = {
	"./activate/activate.route.js": "0xN9",
	"./archive/archive.route.js": "jlcX",
	"./contact/contact.route.js": "5OAZ",
	"./contact/contato.route.js": "8AQ+",
	"./login/login.route.js": "GaWo",
	"./login/logout.route.js": "MQaE",
	"./page-or-not-found/page-or-not-found.route.js": "kM4v",
	"./password/request/request.route.js": "e7OU",
	"./password/reset/reset.route.js": "nCbl",
	"./profile/perfil.route.js": "yjVN",
	"./profile/profile.route.js": "/VDx",
	"./register/cadastro.route.js": "OoGa",
	"./register/register.route.js": "p/bv",
	"./search/search.route.js": "h3SQ",
	"./section/section.route.js": "zin7",
	"./single/order-2-single.route.js": "GEzr",
	"./subscribe/inscricao.route.js": "hiF3",
	"./subscribe/subscribe.route.js": "6qgR",
	"./unsubscribe/unsubscribe.route.js": "zkYE"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "HAhA";